import axios from "axios";
import { PopUpCaller } from "../PopUpWarning/PopUpWarning";

const localhostUrl = "http://localhost:5000"
const ProductUrl = "https://api.lionsragnarokserver.net"
const accessUrl = ProductUrl

const urlAccessListEmail = accessUrl + "/Server/AccessListEmail"
const urlCharList = accessUrl + "/Server/CharList"
const urlLoginCheck = accessUrl + "/Server/LoginCheck"
const urlCreateAccess = accessUrl + "/Server/CreateAccess"
const urlDeleteAccess = accessUrl +"/Server/DeleteAccess"
const urlChangeAccessPassword = accessUrl + "/Server/UpDateAccessPassword"

const API_KEY = "AS7XKLjauheaHN164iylzo2SAJUAHBKUQYTkasNX457";

async function ApiConnectUserAccessList(user) {

    let token = sessionStorage.getItem('jwtToken'); // Ou sessionStorage.getItem('jwtToken');
    let config = {
    headers: {
        'Content-Type': 'application/json',
        'X-API-Key': API_KEY
        },
        validateStatus: function (status) { return true },
    };

    config.headers.Authorization = `Bearer ${token}`;

    const accessData = {
        userEmail: user.userEmail,
        userPassword: user.userPassword
    }

    let result = await axios.post(urlAccessListEmail, accessData, config)
    .then(response => response)

    return result;
                
}

async function ApiConnectUserLoginCheck(login) {

    let token = sessionStorage.getItem('jwtToken'); // Ou sessionStorage.getItem('jwtToken');
    let config = {
    headers: {
        'Content-Type': 'application/json',
        'X-API-Key': API_KEY
        },
        validateStatus: function (status) { return true },
    };

    config.headers.Authorization = `Bearer ${token}`;

    const accessData = {
        login: login,
    }

    let result = await axios.post(urlLoginCheck, accessData, config)

    return result
                
}


async function ApiConnectUserCharList(user) {
    
    let token = sessionStorage.getItem('jwtToken'); // Ou sessionStorage.getItem('jwtToken');
    let config = {
    headers: {
        'Content-Type': 'application/json',
        'X-API-Key': API_KEY
        },
        validateStatus: function (status) { return true },
    };

    config.headers.Authorization = `Bearer ${token}`;

    let result = await axios.post(urlCharList, user, config)

    if(result.data === false) { return false;
    } else {return result.data}
                
}

async function ApiConnectUserCreateAccess(user) {

    let token = sessionStorage.getItem('jwtToken'); // Ou sessionStorage.getItem('jwtToken');
    let config = {
    headers: {
        'Content-Type': 'application/json',
        'X-API-Key': API_KEY
        },
        validateStatus: function (status) { return true },
    };

    config.headers.Authorization = `Bearer ${token}`;

    let DTOuser = {
                    account_id: 0,
                    userid: user.login,
                    user_pass: user.userPassword,
                    sex: user.sex,
                    email: user.email,
                    group_id: user.group_id,
                    vip_time: user.vip_time,
                    logincount: 0,
                    lastlogin: null,
                    character_slots: 0,
                    birthdate: user.birthdate
                    }

    let result = await axios.post(urlCreateAccess, DTOuser, config)
    return result;       
}

async function ApiConnectUserDeleteAccess(accountid, userName, pass, email) {

    let token = sessionStorage.getItem('jwtToken'); // Ou sessionStorage.getItem('jwtToken');
    let config = {
    headers: {
        'Content-Type': 'application/json',
        'X-API-Key': API_KEY
        },
        validateStatus: function (status) { return true },
    };

    config.headers.Authorization = `Bearer ${token}`;

    let DTOuser = {
                    account_id: accountid,
                    userid: userName,
                    user_pass: pass,
                    email: email
                    }
    
    let result = await axios.post(urlDeleteAccess, DTOuser, config)
    .then(response => response)

    return result         
}

async function ApiConnectUserChangeAccessPassword(accountid, userName, pass, email) {

    let token = sessionStorage.getItem('jwtToken'); // Ou sessionStorage.getItem('jwtToken');
    let config = {
    headers: {
        'Content-Type': 'application/json',
        'X-API-Key': API_KEY
        },
        validateStatus: function (status) { return true },
    };

    config.headers.Authorization = `Bearer ${token}`;

    let DTOuser = {
                    account_id: accountid,
                    userid: userName,
                    new_pass: pass,
                    email: email
                    }
    
    let result = await axios.put(urlChangeAccessPassword, DTOuser, config)
    .then(response => response) 
    
    return result
}



export { 
        ApiConnectUserAccessList,
        ApiConnectUserCharList,
        ApiConnectUserLoginCheck,
        ApiConnectUserCreateAccess,
        ApiConnectUserDeleteAccess,
        ApiConnectUserChangeAccessPassword
    };